Common.inputPlaceholder = () => {
	if ('placeholder' in document.createElement('input')) return;

	const inputs = $('input, textarea').filter('[placeholder]')

	inputs.each((i, el) => {
		const $el = $(el)
		const placeholder = $el.attr('placeholder')
		if (!$el.val().length)
			$el.val(placeholder)

		$el.on('focus', () => {
			if ($el.val() == placeholder)
				$el.val('')
		})

		$el.on('blur', () => {
			if (!$el.val().length)
				$el.val(placeholder)
		})
	})
}
